import React from 'react'

export default function ApiCode(props) {
    function copyText(codeid, btnid) {
        // Get the text field
        var copyText = document.getElementById(codeid);

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText.innerText);

        // Alert the copied text
        document.getElementById(btnid).innerHTML = "Text Copied."
        setTimeout(() => {
            document.getElementById(btnid).innerHTML = "Copy"
        }, 2000)
    }
    return (
        <>
            <div className="card-body bg-light">
                <div className="row">
                    <div className="col-md-12">
                        <div id="accordion">
                            <div className="card">
                                <div className="card-header" id="headingOne">
                                    <h5 className="mb-0">
                                        <button
                                            className="btn btn-link"
                                            data-toggle="collapse"
                                            data-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                        >
                                            Send a notification to a single user.
                                        </button>
                                    </h5>
                                </div>
                                <div
                                    id="collapseOne"
                                    className="collapse show"
                                    aria-labelledby="headingOne"
                                    data-parent="#accordion"
                                >
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                    <li class="nav-item">
                                                        <a class="nav-link active" id="js-tab" data-toggle="tab" href="#js" role="tab" aria-controls="js" aria-selected="true">Javascript</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" id="py-tab" data-toggle="tab" href="#py" role="tab" aria-controls="py" aria-selected="false">Python</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" id="curl-tab" data-toggle="tab" href="#curl" role="tab" aria-controls="curl" aria-selected="false">CURL</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" id="php-tab" data-toggle="tab" href="#php" role="tab" aria-controls="php" aria-selected="false">PHP CURL</a>
                                                    </li>
                                                </ul>
                                                <div class="tab-content" id="myTabContent">
                                                    <div class="tab-pane fade show active" id="js" role="tabpanel" aria-labelledby="js-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code-js', 'btn-js')} id='btn-js'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code-js'>
                                                                {` 
var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

var raw = JSON.stringify({
"title": "Webpush Notification",  // title
"body": "Perfection is achieved not whenthere is nothing more to add, but rather when there is nothing more to take away.",  // description
"icon": "https://i.ibb.co/ZHknw4v/423-4235985-bell-notification-bell-icon-transparent-hd-png-download-removebg-preview.png", // icon or image url
"data": "https://www.netflixtrend.com", // destination url (when notification on click go to your post)
"siteUrl": "${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
"userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
});

var requestOptions = {
method: 'POST',
headers: myHeaders,
body: raw,
redirect: 'follow'
};

fetch(${props.apiEndPoint}send/notification/{uid}, requestOptions)
.then(response => response.text())
.then(result => console.log(result))
.catch(error => console.log('error', error));`}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                    <div class="tab-pane fade" id="py" role="tabpanel" aria-labelledby="py-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code-py', 'btn-py')} id='btn-py'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code-py'>
                                                                {` 
import requests
import json

url = ${props.apiEndPoint}send/notification/{uid}

payload = json.dumps({
  "title": "Webpush Notification",  // title
  "body": "Perfection is achieved not whenthere is nothing more to add, but rather when there is nothing more to take away.",  // description
  "icon": "https://i.ibb.co/ZHknw4v/423-4235985-bell-notification-bell-icon-transparent-hd-png-download-removebg-preview.png", // icon or image url
  "data": "https://www.netflixtrend.com", // destination url (when notification on click go to your post)
  "siteUrl": "${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
  "userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
})
headers = {
  'Content-Type': 'application/json'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)
`}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                    <div class="tab-pane fade" id="curl" role="tabpanel" aria-labelledby="curl-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code-curl', 'btn-curl')} id='btn-curl'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code-curl'>
                                                                {` 
 curl --location ${props.apiEndPoint}send/notification/{uid} \
--header 'Content-Type: application/json' \
--data '{
    "title": "Webpush Notification",  // title
    "body": "Perfection is achieved not whenthere is nothing more to add, but rather when there is nothing more to take away.",  // description
    "icon": "https://i.ibb.co/ZHknw4v/423-4235985-bell-notification-bell-icon-transparent-hd-png-download-removebg-preview.png",  // icon or image url
    "data":"https://www.netflixtrend.com", // destination url (when notification on click go to your post)
    "siteUrl":"${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
    "userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
}'`}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                    <div class="tab-pane fade" id="php" role="tabpanel" aria-labelledby="php-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code-php', 'btn-php')} id='btn-php'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code-php'>
                                                                {`
<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => ${props.apiEndPoint}send/notification/{uid},
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS =>'{
    "title": "What Is The LinkedIn Business Strategy For 2023?",  // title
    "body": "In excess of 59 million organizations use LinkedIn Pages to associate with the stage\'s 875 million individuals...",  // description
    "icon": "https://www.yourquorum.com/assets/images/favicon.png", // icon or image url
    "data":"https://www.yourquorum.com/question/what-is-the-linkedin-business-strategy-for-2023", // destination url (when notification on click go to your post)
    "siteUrl":"${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
    "userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
}',
  CURLOPT_HTTPHEADER => array(
    'Content-Type: application/json'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;

                                                                        `}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingTwo">
                                    <h5 className="mb-0">
                                        <button
                                            className="btn btn-link collapsed"
                                            data-toggle="collapse"
                                            data-target="#collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseTwo"
                                        >
                                            Send a notification to every user.
                                        </button>
                                    </h5>
                                </div>
                                <div
                                    id="collapseTwo"
                                    className="collapse"
                                    aria-labelledby="headingTwo"
                                    data-parent="#accordion"
                                >
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                    <li class="nav-item">
                                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Javascript</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Python</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">CURL</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" id="about-tab" data-toggle="tab" href="#about" role="tab" aria-controls="about" aria-selected="false">PHP CURL</a>
                                                    </li>
                                                </ul>
                                                <div class="tab-content" id="myTabContent">
                                                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code1-js', 'btn1-js')} id='btn1-js'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code1-js'>
                                                                {` 
var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

var raw = JSON.stringify({
"title": "Webpush Notification",  // title
"body": "Perfection is achieved not whenthere is nothing more to add, but rather when there is nothing more to take away.",  // description
"icon": "https://i.ibb.co/ZHknw4v/423-4235985-bell-notification-bell-icon-transparent-hd-png-download-removebg-preview.png", // icon or image url
"data": "https://www.netflixtrend.com", // destination url (when notification on click go to your post)
"siteUrl": "${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
"userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
});

var requestOptions = {
method: 'POST',
headers: myHeaders,
body: raw,
redirect: 'follow'
};

fetch(${props.apiEndPoint}send/notification, requestOptions)
.then(response => response.text())
.then(result => console.log(result))
.catch(error => console.log('error', error));`}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                    <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code1-py', 'btn1-py')} id='btn1-py'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code1-py'>
                                                                {` 
import requests
import json

url = ${props.apiEndPoint}send/notification

payload = json.dumps({
  "title": "Webpush Notification",  // title
  "body": "Perfection is achieved not whenthere is nothing more to add, but rather when there is nothing more to take away.",  // description
  "icon": "https://i.ibb.co/ZHknw4v/423-4235985-bell-notification-bell-icon-transparent-hd-png-download-removebg-preview.png", // icon or image url
  "data": "https://www.netflixtrend.com", // destination url (when notification on click go to your post)
  "siteUrl": "${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
  "userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
})
headers = {
  'Content-Type': 'application/json'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)
`}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                    <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code1-curl', 'btn1-curl')} id='btn1-curl'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code1-curl'>
                                                                {` 
 curl --location ${props.apiEndPoint}send/notification \
--header 'Content-Type: application/json' \
--data '{
    "title": "Webpush Notification",  // title
    "body": "Perfection is achieved not whenthere is nothing more to add, but rather when there is nothing more to take away.",  // description
    "icon": "https://i.ibb.co/ZHknw4v/423-4235985-bell-notification-bell-icon-transparent-hd-png-download-removebg-preview.png", // icon or image url
    "data":"https://www.netflixtrend.com", // destination url (when notification on click go to your post)
    "siteUrl":"${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
    "userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
}'`}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                    <div class="tab-pane fade" id="about" role="tabpanel" aria-labelledby="about-tab">
                                                        <pre style={{ padding: "15px" }}>
                                                            <div className="w-100 text-right">
                                                                <button className="btn btn-primary" onClick={() => copyText('code1-php', 'btn1-php')} id='btn1-php'>Copy</button>
                                                            </div>
                                                            <code className="language-javascript" id='code1-php'>
                                                                {`
<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => ${props.apiEndPoint}send/notification,
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS =>'{
    "title": "What Is The LinkedIn Business Strategy For 2023?", // title
    "body": "In excess of 59 million organizations use LinkedIn Pages to associate with the stage\'s 875 million individuals...",  // description
    "icon": "https://www.yourquorum.com/assets/images/favicon.png",  // icon or image url
    "data":"https://www.yourquorum.com/question/what-is-the-linkedin-business-strategy-for-2023", // destination url (when notification on click go to your post)
    "siteUrl":"${props.selectedSite ? props.selectedSite : 'xxxxxxx'}",
    "userId":"${props.user?.id ? props.user?.id : 'xxxxxxx'}"
}',
  CURLOPT_HTTPHEADER => array(
    'Content-Type: application/json'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;

                                                                        `}
                                                            </code>
                                                        </pre>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
